// src/components/forms/icons/AlertCircleIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx } from "react/jsx-runtime";
var AlertCircleIcon = (props) => /* @__PURE__ */ jsx(Icon, { viewBox: "0 0 50 50", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M25 7C15.1 7 7 15.1 7 25C7 34.9 15.1 43 25 43C34.9 43 43 34.9 43 25C43 15.1 34.9 7 25 7ZM27.4 16.4L26.7 26.7H23.4L22.4 16.4H27.4ZM22.7 33.6V29.3H27.5V33.6H22.7Z",
    fill: "currentColor"
  }
) });
var AlertCircleIcon_default = AlertCircleIcon;

export {
  AlertCircleIcon_default
};
